import React, { createContext, useContext, useState } from 'react';
import { IValidator } from '../useValidator/useValidator';

interface IEditContextProps {
  editingId?: number;
  setEditingId: (editingRowId?: number) => void;
  validators: Record<string, IValidator<any>>;
  setValidator: (name: string, validator: IValidator<any>) => void;
  saving?: boolean;
  setSaving: (saving?: boolean) => void;
}

const EditContext = createContext<IEditContextProps>({
  editingId: undefined,
  setEditingId: /* istanbul ignore next */ () => {},
  validators: {},
  setValidator: /* istanbul ignore next */ () => {},
  saving: undefined,
  setSaving: /* istanbul ignore next */ () => {}
});

export const useEditContext = () => useContext(EditContext);

export const EditContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [editingId, setEditingId] = useState<number | undefined>();
  let [validators, setValidators] = useState<Record<string, IValidator<any>>>({});
  const [saving, setSaving] = useState<boolean | undefined>(false);

  const setValidator = (name: string, validator: IValidator<any>) => setValidators((validators = { ...validators, [name]: validator }));

  return (
    <EditContext.Provider
      value={{
        editingId,
        setEditingId,
        validators,
        setValidator,
        saving,
        setSaving
      }}
    >
      {children}
    </EditContext.Provider>
  );
};
